import classNames from "classnames";

export const background = classNames(
    "tablet:bg-[url(/assets/images/backgrounds/awards/x-desktop.svg)]",
    "tablet:bg-left-top",
    "tablet:bg-no-repeat",
    "tablet:bg-[position:18px_-60px]",
    "relative"
)

export const container = classNames(
    // Mobile
    "mobile:mx-14",
    "mobile:w-auto",
    "mobile:",
    "mobile:",
    "mobile:my-0",
    "mobile:mx-8",
    "mobile:p-6",
    // Tablet
    "tablet:mx-80",
    "tablet:my-0",
    "tablet:p-10",
    // All
    "flex",
    "flex-row",
    "w-1/2",
    "border-opacity-30",
    "rounded-xl shadow-lg",
    "items-center",
    "justify-center",
)

export const wrapper = classNames(
    // Mobile
    "mobile:pt-4",
    // Tablet
    "tablet:pt-2",
    // All
    "flex-row",
    "w-full"

)

export const awardImage = classNames(
    // Mobile
    "mobile:max-w-[80px]",
    "mobile:max-h-[100px]",
    "mobile:mr-6",
    // Tablet
    "tablet:max-w-[110px]",
    "tablet:max-h-[100px]",
    "tablet:mr-8",
    // All
)

export const awardHeading = classNames(
    // Mobile
    "mobile:text-sm",
    "mobile:ml-0",
    // Tablet
    "tablet:text-lg",
    "tablet:flex-col",
    // All
    "flex",
    "font-bold",
    "ml-2"
)

export const awardLink = classNames(
    // Mobile
    "mobile:text-sm",
    "mobile:ml-0",
    // Tablet
    "tablet:text-lg",
    // All
    "ml-2",
    "text-primary",
    "cursor-pointer"
)
export const noLink = classNames(
    "text-black"
)

export const awardDate = classNames(
    // Mobile
    "mobile:text-sm",
    "mobile:ml-0",
    // Tablet
    "tablet:text-lg",
    // All
    "ml-2",
)

export const awardDescription = classNames(
    // Mobile
    "mobile:text-sm",
    "mobile:ml-0",
    // Tablet
    "tablet:text-md",
    // All
    "ml-2",
    "mb-2",
)

export const spacing = classNames(
    // Mobile
    "mobile:pt-2",
    // Tablet
    "tablet:pt-4",
    // All
    "invisible"
)
